import { generateReducer, } from "../generators/generator.reducer";
import { GENERATOR_PARAMS } from "./templateDocument.constants";
var getExtraDefaultState = function (state) { return ({}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
export var templateDocumentReducer = _reducer;
